module.exports = __webpack_public_path__ + "static/fakturomania-dotacje.fde8734c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/universal/img/fakturomania-dotacje.jpg
// module id = 828
// module chunks = 168707334958949